/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-unresolved */
import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

import { selectDelivery, selectOrder } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';

interface PaymentObject {
  [key: string]: number;
}

const AmountLeft = () => {
  const {
    total: totalCost,
    customer_balance: customerBalance,
    apply_change: applyChange,
  } = useSelector(selectOrder);
  const { delivery } = useSelector(selectDelivery);
  const { data: profile } = useFetchPosProfileDetails();

  const total = totalCost + (delivery?.delivery_amount || 0);

  const { values } = useFormikContext<any>();

  const filteredObject = Object.keys(values).reduce<PaymentObject>(
    (obj, key) => {
      if (key !== 'loyalty_points') {
        obj[key] = values[key];
      }
      return obj;
    },
    {},
  );

  const objectValues: number[] = Object.values(filteredObject);

  const totalAmount = objectValues.reduce(
    (curr: number, total: number): number => curr + total,
    0,
  );

  const amountToBePaid = total;

  let amountLeft = amountToBePaid - totalAmount;

  if (amountLeft <= 0) {
    amountLeft = 0;
  }

  const amountRemaining =
    customerBalance > amountLeft ? 0 : amountLeft - customerBalance;

  return (
    <Typography
      sx={{
        color: (theme) => theme.palette.primary.main,
        fontWeight: '600',
        fontFamily: 'Montserrat',

        '& span': {
          ml: 1,
        },
      }}
    >
      Amount left:
      <span>
        {profile?.currency}
        {applyChange
          ? amountRemaining.toLocaleString('en-US')
          : amountLeft.toLocaleString('en-US')}
      </span>
    </Typography>
  );
};

export default AmountLeft;
